import { ApolloProvider } from '@apollo/client';

import { GenerateReportsFlowController } from '../features/reports/generate-reports/GenerateReportsFlowController';
import { client } from '../graphql/client';
import { CurrentEmployerContext } from '../utils/currentEmployer';

type Props = {
  employerId: string;
};

export const GenerateReportsApp: React.FC<Props> = props => {
  const { employerId } = props;
  return (
    <ApolloProvider client={client}>
      <CurrentEmployerContext.Provider value={employerId}>
        <GenerateReportsFlowController />
      </CurrentEmployerContext.Provider>
    </ApolloProvider>
  );
};
